import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { reduxForm, SubmissionError } from 'redux-form';
import { updateAccount } from 'dash-front/admin/actions/accounts';
import Snackbar from 'material-ui/Snackbar';
import SectionList from './SectionList';
import PermissionForm from '../forms/PermissionsForm';
import { SectionWrapper } from '../style';

function FeaturesSection({ submit, submitting = false, submitSucceeded = false, submitFailed = false }) {
    return (
        <SectionWrapper>
            <SectionList title="Features" Component={PermissionForm} submit={submit} submitFailed={submitFailed} />
            <Snackbar open={submitting} message="Features saving..." autoHideDuration={10000} />
            <Snackbar open={submitSucceeded} message="Features save" autoHideDuration={3000} />
        </SectionWrapper>
    );
}

FeaturesSection.propTypes = {
    // From reduxForm
    submit: PropTypes.func,
    submitting: PropTypes.bool.isRequired,
    submitSucceeded: PropTypes.bool.isRequired,
    submitFailed: PropTypes.bool.isRequired
};

export default compose(
    connect((state, { permissions }) => ({
        initialValues: { permissions }
    })),
    reduxForm({
        form: 'editAccount',
        onSubmit: ({ permissions }, dispatch, { userId }) => {
            return dispatch(updateAccount(userId, { permissions })).then(({ body, status }) => {
                if (status >= 400) {
                    throw new SubmissionError(body);
                }
            });
        },
        pure: true,
        enableReinitialize: true
    })
)(FeaturesSection);



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/components/Account/UpdateAccount/FeaturesSection.js
 **/